import React from "react";
import { profileImgPlaceholder } from "../../../../assets/images";
import { Domain, request } from "../../../../config/API";
import { COLORS } from "../../../../config/theme";
import MainIconBar from "../MainIconBar";
import InfoBox from "../InfoBox";
import { Col, Row } from "antd";
import SocialIconBar from "../SocialIconBar";
const Theme9 = ({ vCard, isPreview, downloadVcfFile, setShowExchangeCard }) => {
  const { primaryColor } = COLORS;
  const {
    fNamePrefix,
    fName,
    lName,
    lNameSuffix,
    email,
    company,
    jobTitle,
    mobile,
    address,
    bgImage,
    profileImage,
    pColor,
    sColor,
    socialLinks,
    leadEnable,
    owner,
    webLinks,
  } = vCard;

  return (
    <Col
      style={{
        width: "100%",
        background: `linear-gradient(to bottom, rgba(0,0, 0, 0.8), rgba(0, 0,0, 1))`,
      }}
    >
      <Col
        style={{
          position: "relative",
          background: `linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0,0, 1)),
      ${bgImage ? `url(${Domain}/data/${bgImage})` : pColor}`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          overflow: "hidden",
          backgroundPosition: "center",
          height: "460px",
        }}
      >
        <Row
          span={24}
          style={{
            display: "flex",
            position: "absolute",
            bottom: 50,
            width: "100%",
          }}
        >
          <Col
            span={10}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              position: "relative",
              left: 16.5,
            }}
          >
            <div
              style={{
                border: `15px solid ${sColor}`,
                borderRadius: 100,
                overflow: "hidden",
                zIndex: 10,
              }}
            >
              <img
                draggable={false}
                style={{
                  height: 120,
                  width: 120,
                  borderRadius: 50,
                }}
                src={
                  profileImage
                    ? `${Domain}/data/${profileImage}`
                    : profileImgPlaceholder
                }
                alt=""
              />
            </div>
          </Col>
          <Col
            span={14}
            style={{
              position: "relative",
              top: 28,
            }}
          >
            <Row
              style={{
                backgroundColor: sColor,
                overflow: "hidden",
                paddingLeft: 30,
                paddingTop: 5,
                paddingBottom: 5,
                overflow: "hidden",
                minHeight: "63%",
              }}
            >
              <InfoBox
                fName={fName}
                jobTitle={jobTitle}
                company={company}
                black={false}
              />
            </Row>
            <Row
              style={{
                paddingTop: 10,
                paddingLeft: 20,
              }}
            >
              <MainIconBar
                mobile={mobile}
                email={email}
                address={address}
                sColor={sColor}
                horizontal={true}
              />
            </Row>
          </Col>
        </Row>
      </Col>
      <SocialIconBar
        socialLinks={socialLinks}
        leadEnable={leadEnable}
        sColor={sColor}
        downloadVcfFile={downloadVcfFile}
        setShowExchangeCard={setShowExchangeCard}
        owner={owner}
        isBlack={false}
        webLinks={webLinks}
        isPreview={isPreview}
      />
    </Col>
  );
};

export default Theme9;
